module.exports = __webpack_public_path__ + "static/media/2020-10-28 16.27.23.f4a31ffc.jpg";